"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedIcon = void 0;
const UiElements_1 = require("../ui/UiElements");
const assetVersionType_1 = require("../../enums/assetVersionType");
class EmbedIcon {
    constructor(assetId, assetVersionType, showEmbedIcon) {
        var _a;
        this.url = '##EMBED_SOURCE_URL##';
        this.embedFunctions = {
            redirectToWebsite: () => this.redirectToWebsite()
        };
        let menuEl;
        if (document.querySelector('#flexEmbedLoading') != null) {
            menuEl = document.querySelector('#flexEmbedLoading');
        }
        else {
            menuEl = document.querySelector('#flexMiniEmbedLoading');
        }
        this.assetId = assetId;
        if (((_a = this.url) === null || _a === void 0 ? void 0 : _a.includes('https://')) == false) {
            console.warn("##EMBED_SOURCE_URL## is not set");
            this.url = 'https://weave.dev.ms.arctur.io/asset/';
        }
        if (!menuEl) {
            throw new Error('flex container is undefined');
        }
        const embedSourceHostName = new URL(this.url).host;
        this.embedElement = this.createElement();
        this.embedElement.setEvent('click', this.embedFunctions.redirectToWebsite);
        //If you want to see the embed icon while in development you need to change the following syntax
        //'assetVersionType == AssetVersionType.PUBLISHED' to 'assetVersionType == AssetVersionType.PRIVATE'
        //If the asset is PRIVATE or on the source site the embed won't show
        if (assetVersionType == assetVersionType_1.AssetVersionType.PUBLISHED && window.location.hostname.includes(embedSourceHostName) == false && showEmbedIcon) {
            menuEl.appendChild(this.embedElement.domEl);
        }
    }
    createElement() {
        return new UiElements_1.DivEl()
            .setId('embedIcon');
    }
    redirectToWebsite() {
        window.open(`${this.url}${this.assetId}`, '_blank');
    }
    dispose() {
        this.removeEvents();
    }
    removeEvents() {
        var _a;
        (_a = this.embedElement) === null || _a === void 0 ? void 0 : _a.removeEvent('click', this.embedFunctions.redirectToWebsite);
    }
}
exports.EmbedIcon = EmbedIcon;
